import { Radio } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { MyForm } from '~/components/ui/MyForm'
import { SuperType } from '~/graphqls/types'
import {
  optionsAtom,
  resolutionPointAtom,
  selectResolutionAtom,
  selectSizeAtom,
} from './atom'
import styles from '../AiForm.module.css'
import { isNullOrUndefined } from '~/utils'
import { useStores } from '~/hooks/useStores'
import useOptions from './useOptions'

export const PictureResolutionComp = () => {
  const [options] = useAtom(optionsAtom)
  const [, setResolutionPoint] = useAtom(resolutionPointAtom)
  const [selectResolution, setSelectResolution] = useAtom(selectResolutionAtom)
  const [selectSize] = useAtom(selectSizeAtom)

  const { store } = useStores()
  const { curResolution } = useOptions()
  const curResolutionOptions = curResolution[selectSize] || []

  /** 是否是会员 */
  const isMember = store.userinfo?.memberDetail?.hold || false
  const isHighUser = isMember || options?.inWhiteList

  useEffect(() => {
    if (!curResolutionOptions.length) return

    const index = curResolutionOptions.findIndex(
      item =>
        `${item.length}*${item.width}*${item.superType}` === selectResolution
    )
    if (index === -1) {
      setSelectResolution(
        `${curResolutionOptions[0].length}*${curResolutionOptions[0].width}*${curResolutionOptions[0].superType}`
      )
      setResolutionPoint(curResolutionOptions[0].price)
    }
  }, [curResolutionOptions, selectResolution])

  useEffect(() => {
    // 更新积分
    const index = curResolutionOptions.findIndex(
      item =>
        `${item.length}*${item.width}*${item.superType}` === selectResolution
    )
    if (index > -1) {
      let point = curResolutionOptions[index].price
      if (
        isHighUser &&
        !isNullOrUndefined(curResolutionOptions[index].membersPrice)
      ) {
        point = curResolutionOptions[index].membersPrice!
      }

      setResolutionPoint(point)
    }
  }, [curResolutionOptions, selectResolution])

  return (
    <MyForm.Item noStyle>
      <Radio.Group
        className={classNames(
          styles.customRadioGroup,
          styles.customPrefineRadio,
          '!mb-8'
        )}
        onChange={e => {
          setSelectResolution(e.target.value)
        }}
        value={selectResolution}
      >
        {curResolutionOptions.map(item => {
          return (
            <Radio
              value={`${item?.length}*${item?.width}*${item?.superType}`}
              key={`${item?.length}*${item?.width}*${item?.superType}`}
              className={styles.customRadio}
            >
              <div
                className={classNames('radioWrap', {
                  prefine: item.superType === SuperType.PREFINE,
                })}
              >
                <div className="bg-neutral-100 rounded-full">
                  <div
                    className={classNames(
                      'flex items-center justify-center cursor-pointer p-2 border-2 border-solid border-neutral-200 rounded-full duration-75 flex-1 text-center text-xs w-full bg-neutral-200'
                    )}
                  >
                    <div className="text-neutral-800 font-semibold">
                      {`${item?.length}*${item?.width}`}
                      {!!item.price &&
                        !isNullOrUndefined(item.membersPrice) &&
                        isHighUser && (
                          <>
                            <span className="text-neutral-500 ml-1">
                              {item.membersPrice}积分/张
                            </span>
                            <span
                              className={classNames(
                                'text-neutral-500 ml-1',
                                styles.delPrice
                              )}
                            >
                              {item.price}积分
                            </span>
                          </>
                        )}
                      {!!item.price &&
                        (isNullOrUndefined(item.membersPrice) ||
                          !isHighUser) && (
                          <span className="text-neutral-500 ml-1">
                            {item.price}积分/张
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
